export const firebaseConfig = {
    apiKey: "AIzaSyAVpW2pyhR4WzxzpHQrOui9tN9uOpLmuCE",
    authDomain: "psi-product-zdfd-deploy-03.firebaseapp.com",
    databaseURL: "https://psi-product-zdfd-deploy-03-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "psi-product-zdfd-deploy-03",
    storageBucket: "psi-product-zdfd-deploy-03.firebasestorage.app",
    messagingSenderId: "1044916255230",
    appId: "1:1044916255230:web:4db8680f81ccf44f07a8af",
};
